var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplyIspo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.875 6.125L6.125 6.125",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.875 6.125L6.125 6.125",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.875 9.625L6.125 9.625",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.875 9.625L6.125 9.625",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.125L6.125 13.125",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.125L6.125 13.125",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.375 1.75H4.625C3.52043 1.75 2.625 2.64543 2.625 3.75V16.4043C2.625 17.7896 3.99912 18.7553 5.30244 18.2861L6.2392 17.9489C6.72721 17.7732 7.26439 17.794 7.73737 18.0068L9.67927 18.8807C10.2012 19.1155 10.7988 19.1155 11.3207 18.8807L13.2626 18.0068C13.7356 17.794 14.2728 17.7732 14.7608 17.9489L15.6976 18.2861C17.0009 18.7553 18.375 17.7896 18.375 16.4043V3.75C18.375 2.64543 17.4796 1.75 16.375 1.75Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.375 1.75H4.625C3.52043 1.75 2.625 2.64543 2.625 3.75V16.4043C2.625 17.7896 3.99912 18.7553 5.30244 18.2861L6.2392 17.9489C6.72721 17.7732 7.26439 17.794 7.73737 18.0068L9.67927 18.8807C10.2012 19.1155 10.7988 19.1155 11.3207 18.8807L13.2626 18.0068C13.7356 17.794 14.2728 17.7732 14.7608 17.9489L15.6976 18.2861C17.0009 18.7553 18.375 17.7896 18.375 16.4043V3.75C18.375 2.64543 17.4796 1.75 16.375 1.75Z",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyIspo);
export default __webpack_public_path__ + "static/media/apply-ispo.bdb3ff696f90937fc359a5a78a2b923b.svg";
export { ForwardRef as ReactComponent };